<template>
  <div class="header wow slideInDown">
    <div class="container">
      <div class="row">
        <div class="b1 col-md-6 text-center" data-wow-duration="1s">
          <h3>Dawini Dz</h3>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit.
            Dignissimos voluptatibus fugiat magni recusandae sint doloremque
            modi corporis illum, quasi numquam.
          </p>
          <a
            name=""
            id=""
            class="btn btn-primary download"
            href="https://play.google.com/store/apps/details?id=com.zaki.talktome"
            role="button"
            >Doanload App<i class="fab fa-android ml-2"></i
          ></a>
        </div>
        <div
          class="col-md-6 d-none d-md-block wow slideInRight imgright"
          data-wow-duration="1s"
        >
          <img
            src="@/assets/image/Background.png"
            class="img-fluid lazy"
            alt="background header"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>   

<style lang="scss">
/* start header */
.header {
  position: relative;
  color: white;
  margin-top: -21px;
  width: 100%;
  background: url("../assets/image/compo2.png") no-repeat center center;
  height: 699px;
}
.b1 {
  padding-top: 120px;
  padding-bottom: 120px;
}

.download {
  color: #007bff !important;
  background-color: #fff !important;
  border-color: #fff !important;
  border-radius: 50px !important;
  margin-top: 15px;
  padding: 0.55rem 1.25rem !important;
}
.imgright {
  margin-top: 55px;
}
</style>